import React from 'react';
import {colors} from '../../../style/constants';
import InnerLinkButton from '../../../components/svgs/buttons/InnerLinkButton';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {graphql, useStaticQuery} from 'gatsby';
import { GatsbyImage } from "gatsby-plugin-image";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    background: colors.ATT_BLUE,
    '& p': {
      margin: '30px 0'
    },
    '& h2, p': {
      paddingRight: 60,
      color: colors.WHITE
    },
    '& .gatsby-image-wrapper': {
      width: '100%',
      marginBottom: -160
    },
    '& a': {
      marginRight: 30,
      [theme.breakpoints.down('xs')]: {
        marginBottom: 15,
      }
    },
    [theme.breakpoints.down('sm')]: {
      '& .gatsby-image-wrapper': {
        width: '40%',
        margin: 'auto',
        marginBottom: -220
      },
      '& > div > div': {
        '& > :last-child': {
          justifyContent: 'flex-start',
          marginBottom: 30,
        }
      }
    }
  },
}));

const QmHardwareSection = (props) => {
  const data = useStaticQuery(graphql`
    query qmHardwareImage {
      image: file(relativePath: { eq: "qm/hardware.png"}) {
        id
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            quality: 90
          )
        }
      }
    }
  `)

  const classes = useStyles();
  return (
    <section className={classes.wrapper + " clipped"}>
      <Container id="home-content-manager">
        <Grid container alignItems='center'>
          <Grid item sm={12} md={8}>
            <h2>{props.lang === 'en-CA' ? 'Our queue management equipment' : 'Nos équipements de gestion d\'accueil'}</h2>
            <p>{props.lang === 'en-CA' ? 'Thanks to our cloud solution, Moviik allows us to reduce equipment installation. You will need a call terminal and dynamic display screens.' : 'Grâce à notre solution CLOUD, Moviik nous permet d\'alléger l\'installation d\'équipements. Vous aurez besoin d\'une borne d\'appel et d\'écrans d\'affichage dynamique.'}</p>
            <p>{props.lang === 'en-CA' ? 'Our solution is compatible with Samsung Tizen smart screens and avoids the addition of players behind the screens.' : 'Notre solution est compatible avec les écrans intelligents Samsung Tizen et permet d\'éviter l\'ajout de players derrière les écrans.'}</p>
            <p>{props.lang === 'en-CA' ? 'Our kiosks are sturdy and modern and fit well into your decor. Depending on your furniture, you can place the kiosk on a counter, or opt for our model on a stand.' : 'Nos bornes sont robustes et modernes et elles s\'intègrent bien à votre décor. Selon votre mobilier, vous pouvez déposer la borne sur un comptoir, ou opter pour notre modèle sur un pied.'}</p>
            <a href='https://www.moviik.com/kiosks' aria-label={props.lang === 'en-CA' ? 'Moviik Kiosks' : 'Bornes Moviik'}><InnerLinkButton text={props.lang === 'en-CA' ? 'Moviik Kiosks' : 'Bornes Moviik'} /></a>
          </Grid>
          <Grid container justifyContent="flex-end" item sm={12} md={4}>
            <GatsbyImage image={data.image.childImageSharp.gatsbyImageData}  alt="Content driven - Axés sur le contenu"/>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}

export default QmHardwareSection;